/* eslint-disable prettier/prettier */
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import AttachmentIcon from '@mui/icons-material/Attachment';
import BallotIcon from '@mui/icons-material/Ballot';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import HandymanIcon from '@mui/icons-material/Handyman';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import InsertInvitationOutlinedIcon from '@mui/icons-material/InsertInvitationOutlined';
import InsertLinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined';
import MapIcon from '@mui/icons-material/Map';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import SettingsRemoteOutlinedIcon from '@mui/icons-material/SettingsRemoteOutlined';
import TimeToLeaveOutlinedIcon from '@mui/icons-material/TimeToLeaveOutlined';

import { RoutePaths } from '@shared/config/routePathsEnum';
import { ExtractTypeFromArray } from '@shared/types/utility';

export const frontendVersion = '1.146.10';

export const NAV_LINKS = [
  { path: RoutePaths.events, nameKey: 'nav.events', icon: <InsertInvitationOutlinedIcon /> },
  { path: RoutePaths.users, nameKey: 'nav.users', icon: <GroupOutlinedIcon /> },
  { path: RoutePaths.roles, nameKey: 'nav.roles', icon: <ContactsOutlinedIcon /> },
  { path: RoutePaths.groups, nameKey: 'nav.groups', icon: <HomeWorkOutlinedIcon /> },
  { path: RoutePaths.transport, nameKey: 'nav.transport', icon: <TimeToLeaveOutlinedIcon /> },
  { path: RoutePaths.alcolocks, nameKey: 'nav.alcolocks', icon: <SettingsRemoteOutlinedIcon /> },
  { path: RoutePaths.servicemode, nameKey: 'nav.serviceMode', icon: <EngineeringOutlinedIcon /> },
  {
    path: RoutePaths.servicemodehistory,
    nameKey: 'nav.serviceModeHistory',
    icon: <BallotIcon />,
  },
  { path: RoutePaths.links, nameKey: 'nav.attachments', icon: <InsertLinkOutlinedIcon /> },
  { path: RoutePaths.mailings, nameKey: 'nav.mailings', icon: <EmailOutlinedIcon /> },
  { path: RoutePaths.templates, nameKey: 'nav.messageTemplates', icon: <AttachmentIcon /> },
  { path: RoutePaths.settings, nameKey: 'nav.settings', icon: <HandymanIcon /> },
  { path: RoutePaths.reports, nameKey: 'nav.reports', icon: <AssessmentOutlinedIcon /> },
  { path: RoutePaths.mpoConfig, nameKey: 'nav.mpoConfig', icon: <PhoneAndroidOutlinedIcon /> },
  { path: RoutePaths.map, nameKey: 'nav.map', icon: <MapIcon /> },
];

export type TypeNavLinks = typeof NAV_LINKS;
export type TypeNavLink = ExtractTypeFromArray<TypeNavLinks>;
export type TypeNavPath = TypeNavLink['path'];
